<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Adicionar recurso humano</h2>
      <FormPerson @submit-requested="submitRequested"></FormPerson>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormPerson from '../forms/FormPerson.vue'

  export default {
  components: { FormPerson },
    methods: {
      ...mapActions('people', ['addPerson']),
      submitRequested (inputPerson) {
        this.addPerson(inputPerson);
      },
    }
  }
</script> 
 
<style scoped>
</style> 